// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ci-4";
export var closeButton = "_ci-6";
export var dismissButton = "_ci-3";
export var editImageWithAiContainer = "_ci-8";
export var imageUploadWrapper = "_ci-7";
export var misspelledWord = "_ci-5";
export var spellCheckContainer = "_ci-2";
export var spin = "_ci-1";
export var spinning = "_ci-0";